import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
};

// Utility function to clean up modal backdrops and modal state
export const cleanupModalBackdrops = () => {
  try {
    // Remove any lingering modal backdrops
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach(backdrop => {
      if (backdrop && backdrop.parentNode) {
        backdrop.parentNode.removeChild(backdrop);
      }
    });
    
    // Remove modal-open class from body
    if (document.body) {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
    
    // Close any open Bootstrap modals
    const openModals = document.querySelectorAll('.modal.show');
    openModals.forEach(modal => {
      try {
        if (window.bootstrap && window.bootstrap.Modal) {
          const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
          if (bootstrapModal) {
            bootstrapModal.hide();
          }
        }
      } catch (error) {
        console.warn('Error closing Bootstrap modal:', error);
      }
    });
    
    // Additional cleanup for any remaining modal-related elements
    const remainingBackdrops = document.querySelectorAll('[class*="backdrop"]');
    remainingBackdrops.forEach(element => {
      if (element.classList.contains('modal-backdrop') || element.style.position === 'fixed') {
        element.remove();
      }
    });
    
  } catch (error) {
    console.warn('Error during modal cleanup:', error);
  }
}; 